export default {
  NEWS: 'news',
  SALES: 'sales',
  EVENTS: 'events',
  GAMES: 'game',
  FEATURED_GAMES: 'featured-game',
  NEW_GAMES: 'new-game'
};